import React, { useState, useEffect, useCallback, useRef } from 'react';
import { format, parse } from 'date-fns';
import DateRangePicker from '@/components/ui/DateRangePicker';
import PagesWrapper from '@/components/ui/shared/PagesWrapper';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Search, SlidersHorizontal, Loader2, ChevronDown } from 'lucide-react';
import ListChartWidget from '../ListChartWidget';
import ColumnPieChart from '../ColumnPieChart';
import FilterTagCom from '../FilterTag';
import { userService } from '../../_services';
import { Redirect, NavLink } from "react-router-dom";
import { cn, safeParseDate } from '@/lib/utils';
import { computeMenuAlignFromTrigger, absoluteMenuAlignClasses } from '../../_helpers/dropdownViewportAlign';

function Pharmacies({ AnalyticData, handeChangefilter }) {
    // Initialize dates
    const getInitialDates = () => {
        const defaultStartDate = new Date();
        defaultStartDate.setDate(defaultStartDate.getDate() - 30);
        const defaultEndDate = new Date();
        
        const storedStartDate = localStorage.getItem('User_Start_Date');
        const storedEndDate = localStorage.getItem('User_End_Date');
        
        const startdate = (storedStartDate && storedStartDate !== "" && storedStartDate !== "null")
            ? safeParseDate(storedStartDate, defaultStartDate)
            : defaultStartDate;
        const enddate = (storedEndDate && storedEndDate !== "" && storedEndDate !== "null")
            ? safeParseDate(storedEndDate, defaultEndDate)
            : defaultEndDate;
        
        return {
            startDate: startdate,
            endDate: enddate
        };
    };

    const initialDates = getInitialDates();
    const [startDate, setStartDate] = useState(initialDates.startDate);
    const [endDate, setEndDate] = useState(initialDates.endDate);
    const [graphData, setGraphData] = useState([]);
    const [scrollArray, setScrollArray] = useState({});
    const [dashboardName, setDashboardName] = useState('');
    const [dist_usertype, setDist_usertype] = useState('Direct');
    const [FilterTagList, setFilterTagList] = useState(() => {
        try {
            const stored = localStorage.getItem('Advance_Filter');
            return stored && stored !== "null" && stored !== "{}" ? stored : '';
        } catch {
            return '';
        }
    });
    const [searchDisplay, setSearchDisplay] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [showSearchResults, setShowSearchResults] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [userFilterList, setUserFilterList] = useState([]);
    const searchInputRef = useRef(null);
    const filterDropdownWrapRef = useRef(null);
    const filterButtonRef = useRef(null);
    const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
    const [filterMenuAlign, setFilterMenuAlign] = useState('start');
    const directOverrideTriggerRef = useRef(null);
    const [directOverrideAlign, setDirectOverrideAlign] = useState('start');
    const [userdata] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('user'));
        } catch {
            return null;
        }
    });
    
    // Claim Type tabs state
    const [ClaimType, setClaimType] = useState(() => {
        const storedType = localStorage.getItem('Updated_HD_Type') || 'totalpaid';
        return [
            { id: "totalpaid1", value: "totalpaid", isChecked: storedType === 'totalpaid', pname: "Total" },
            { id: "reversed3", value: "reversed", isChecked: storedType === 'reversed', pname: "Reversed" },
            { id: "netpaid2", value: "netpaid", isChecked: storedType === 'netpaid', pname: "Net" },
            { id: "compensable4", value: "compensable", isChecked: storedType === 'compensable', pname: "Paid" }
        ];
    });

    // Calculate roletype, rolename, wh_Id
    const getRoleInfo = useCallback(() => {
        if (!userdata) return { roletype: '', rolename: '', wh_Id: 0 };
        
        let _roletype = '';
        let _rolename = '';
        let _wh_Id = 0;
        
        try {
            if (userdata.userrole == "Distributor" && userdata.wholesaler == "Avenelllllll") {
                _roletype = "avdistributor";
                _rolename = userdata.email;
                _wh_Id = userdata.wholesaler_Id;
            } else if (userdata.userrole == "Distributor" && userdata.wholesaler != "Avenelllll") {
                _roletype = "distributor";
                _rolename = userdata.paramsname;
                _wh_Id = userdata.wholesaler_Id;
            } else {
                _roletype = userdata.userrole;
                _rolename = userdata.paramsname;
                _wh_Id = userdata.wholesaler_Id;
            }
        } catch (error) {
        }
        
        return { roletype: _roletype, rolename: _rolename, wh_Id: _wh_Id };
    }, [userdata]);

    const roleInfo = getRoleInfo();

    const changeData = useCallback((dateChanged, stdate, endate, ftype = '') => {
        let startDateObj = '';
        let endDateObj = '';
        let AllDirectOverride = ftype == '' ? dist_usertype : ftype;
        
        if (dateChanged == undefined) {
            startDateObj = startDate;
            endDateObj = endDate;
        } else {
            startDateObj = stdate;
            endDateObj = endate;
        }

        let AdFilterJson = '';
        try {
            AdFilterJson = JSON.parse(localStorage.getItem('Advance_Filter'));
            if (AdFilterJson != null && AdFilterJson != '' && AdFilterJson != undefined && AdFilterJson != "null") {
                setFilterTagList(JSON.stringify(AdFilterJson));
            } else {
                setFilterTagList('');
            }
        } catch (error) {
            setFilterTagList('');
        }
        
        const startDateFormatted = format(safeParseDate(startDateObj), "yyyyMMdd");
        const endDateFormatted = format(safeParseDate(endDateObj), "yyyyMMdd");
        const changedStartDate = format(parse(startDateFormatted, "yyyyMMdd", new Date()), "MM/dd/yyyy");
        const changedEndDate = format(parse(endDateFormatted, "yyyyMMdd", new Date()), "MM/dd/yyyy");
        setStartDate(changedStartDate);
        setEndDate(changedEndDate);
        
        const Table_Pharmacy_RequestJson = "{\"wname\"" + ":\"" + userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDateFormatted + "\",\"end_date\"" + ":\"" + endDateFormatted + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + userdata["wholesaler_Id"] + "\"}";
        const PatientSavings_Pharmacy_RequestJson = "{\"wname\"" + ":\"" + userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDateFormatted + "\",\"end_date\"" + ":\"" + endDateFormatted + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + userdata["wholesaler_Id"] + "\"}";
        const PaidClaims_By_PharmacyChain_RequestJson = "{\"wname\"" + ":\"" + userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDateFormatted + "\",\"end_date\"" + ":\"" + endDateFormatted + "\",\"chart_type\"" + ":\"" + "pielist\"" + ",\"rcount\"" + ":" + 30 + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + userdata["wholesaler_Id"] + "\"}";
        
        let APIBaseURL = "";
        if (AllDirectOverride === 'All')
            APIBaseURL = '/api/ws_All_Filter';
        else if (AllDirectOverride === 'Direct')
            APIBaseURL = '/api/ws';
        else if (AllDirectOverride === 'Override')
            APIBaseURL = '/api/ws_Override_Filter';
        else
            APIBaseURL = '/api/ws';
        
        const graphDataArray = [
            {
                url: APIBaseURL + "/pharmacy_transaction_new",
                type: "List",
                title: "Transactions by Pharmacy",
                Subtitle: "Number of transactions at each pharmacy",
                ColorCode: "#ffba10",
                XlabelString: "",
                YlabelString: "",
                id: "WPharmacyTransaction1",
                RequestJson: Table_Pharmacy_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/patientsavings_new",
                type: "List",
                title: "Patient Savings by Pharmacy",
                Subtitle: "Patient savings in $ at each pharmacy",
                ColorCode: "#ffba10",
                XlabelString: "",
                YlabelString: "",
                id: "WPatientSavingTransaction",
                RequestJson: PatientSavings_Pharmacy_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/pharmacy_chain_paid_claims",
                type: "Column_Pie",
                title: "Paid Claims (%) by Pharmacy Chain",
                Subtitle: "Paid claims % broken down by Pharmacy Chain",
                ColorCode: "#ffba10",
                DataType: "Pharmacy Chain",
                XlabelString: "",
                YlabelString: "",
                id: "ComOverview_pharmacy_chain_paid_claims",
                RequestJson: PaidClaims_By_PharmacyChain_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            },
            {
                url: APIBaseURL + "/pharmacychainpaidclaimsnumber",
                type: "Column_Pie",
                title: "Paid Claims by Pharmacy Chain",
                Subtitle: "Paid claims broken down by Pharmacy Chain",
                XlabelString: "States",
                YlabelString: "Paid Claims",
                ColorCode: "#ffba10",
                DataType: "Pharmacy Chain",
                id: "PharmacyChainPaidClaimsWholesaler",
                RequestJson: PaidClaims_By_PharmacyChain_RequestJson,
                RequestJson1: JSON.stringify(AdFilterJson)
            }
        ];
        
        setDashboardName('');
        setGraphData(graphDataArray);
    }, [startDate, endDate, dist_usertype, userdata]);

    const handleCalendar = useCallback((e, picker) => {
        const changedStartDate = format(safeParseDate(picker.startDate), "MM/dd/yyyy");
        const changedEndDate = format(safeParseDate(picker.endDate), "MM/dd/yyyy");
        localStorage.setItem('User_Start_Date', changedStartDate);
        localStorage.setItem('User_End_Date', changedEndDate);
        changeData(true, changedStartDate, changedEndDate);
    }, [changeData]);

    const searchWholesalers = useCallback(async (text) => {
        if (text.length < 2) {
            setSearchDisplay([]);
            setShowSearchResults(false);
            setSearchLoading(false);
            return;
        }
        
        setSearchLoading(true);
        
        try {
            const response = await fetch('/api/Filter/SearchOnTypeText', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    text,
                    roletype: roleInfo.roletype || '',
                    rolename: roleInfo.rolename || '',
                    whname: roleInfo.wh_Id ? roleInfo.wh_Id.toString() : ''
                })
            });
            const data = await response.json();
            setSearchDisplay(data || []);
            setShowSearchResults(true);
            setSearchLoading(false);
        } catch (error) {

            setSearchDisplay([]);
            setSearchLoading(false);
        }
    }, [roleInfo]);

    const handleSearchChange = useCallback((e) => {
        const value = e.target.value;
        setSearchValue(value);
        searchWholesalers(value);
    }, [searchWholesalers]);

    const handleSearchFocus = useCallback(() => {
        if (searchValue.length >= 2 && searchDisplay.length > 0) {
            setShowSearchResults(true);
        }
    }, [searchValue, searchDisplay]);

    const handleSearchItemClick = useCallback((item) => {
        try {
            // SearchOnTypeText returns ctype, cvalue structure
            if (!item || !item.ctype || !item.cvalue) {
                return;
            }
            
            let Created_Advance_Filter = JSON.parse(localStorage.getItem('Advance_Filter')) || {};
            const filterKey = item.ctype; // Use the ctype from the API response
            
            if (Created_Advance_Filter[filterKey]) {
                if (!Created_Advance_Filter[filterKey].includes(item.cvalue)) {
                    Created_Advance_Filter[filterKey].push(item.cvalue);
                }
            } else {
                Created_Advance_Filter[filterKey] = [item.cvalue];
            }
            
            localStorage.setItem('Advance_Filter', JSON.stringify(Created_Advance_Filter));
            localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
            localStorage.setItem('Prev_Filter_Status', localStorage.getItem('Updated_Filter_Status'));
            localStorage.setItem('Updated_Filter_Status', 'true');
            
            setSearchValue('');
            setShowSearchResults(false);
            changeData();
        } catch (error) {
            console.error('Error handling search item click:', error);
        }
    }, [changeData]);

    const filterDropdown = useCallback((event) => {
        event.stopPropagation();
        setFilterDropdownOpen((prev) => {
            const next = !prev;
            if (next) setFilterMenuAlign(computeMenuAlignFromTrigger(filterButtonRef.current));
            return next;
        });
    }, []);

    // Handle Claim Type tab click (Total/Reversed/Net/Paid)
    const HandleRXSRadioButton = useCallback((event) => {
        const selectedValue = event.target.value;
        
        // Update ClaimType state - set the clicked one as checked
        setClaimType(prev => prev.map(item => ({
            ...item,
            isChecked: item.value === selectedValue
        })));
        
        // Update localStorage
        localStorage.setItem('Updated_HD_Type', selectedValue);
        localStorage.setItem('Filter_Last_Update_Time', new Date().toISOString());
        
        // Handle PBM: HD filter based on claim type
        if (selectedValue !== 'totalpaid') {
            // Add PBM: HD filter for non-totalpaid claim types
            try {
                let advanceFilter = JSON.parse(localStorage.getItem('Advance_Filter'));
                if (!advanceFilter) advanceFilter = {};
                if (!advanceFilter.PBM) advanceFilter.PBM = [];
                if (!advanceFilter.PBM.includes('HD')) {
                    advanceFilter.PBM.push('HD');
                }
                localStorage.setItem('Advance_Filter', JSON.stringify(advanceFilter));
                localStorage.setItem('Updated_AdFilter_Status', JSON.stringify(advanceFilter));
            } catch (error) {
                localStorage.setItem('Advance_Filter', '{"PBM":["HD"]}');
                localStorage.setItem('Updated_AdFilter_Status', '{"PBM":["HD"]}');
            }
        } else {
            // Remove PBM: HD filter when switching to Total (totalpaid)
            try {
                let advanceFilter = JSON.parse(localStorage.getItem('Advance_Filter'));
                if (advanceFilter && advanceFilter.PBM) {
                    const hdIndex = advanceFilter.PBM.indexOf('HD');
                    if (hdIndex > -1) {
                        advanceFilter.PBM.splice(hdIndex, 1);
                        if (advanceFilter.PBM.length === 0) {
                            delete advanceFilter.PBM;
                        }
                        const filterString = Object.keys(advanceFilter).length === 0 ? null : JSON.stringify(advanceFilter);
                        localStorage.setItem('Advance_Filter', filterString);
                        localStorage.setItem('Updated_AdFilter_Status', filterString || '');
                    }
                }
            } catch (error) {
                // Silent fail
            }
        }
        
        // Trigger data reload
        changeData();
    }, [changeData]);

    const handleAdFilterClick = useCallback((event) => {
        const filterId = event.target.getAttribute('data-filterid');
        if (!filterId) return;
        
        const selectedFilter = userFilterList.find(f => f.dashboardId === parseInt(filterId));
        if (selectedFilter) {
            try {
                const parsedFilter = JSON.parse(selectedFilter.filterJson);
                const rawDataset = parsedFilter.dataset;
                const filterDataset = (rawDataset && typeof rawDataset === 'object' && Object.keys(rawDataset).length > 0)
                    ? JSON.stringify(rawDataset)
                    : null;
                
                localStorage.setItem('Advance_Filter', filterDataset);
                localStorage.setItem('Updated_AdFilter_Status', filterDataset);
                localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
                localStorage.setItem('Prev_Filter_Status', localStorage.getItem('Updated_Filter_Status'));
                localStorage.setItem('Updated_Filter_Status', 'true');
                
                setFilterDropdownOpen(false);

                changeData();
            } catch (error) {

            }
        }
    }, [userFilterList, changeData]);

    const loadUserFilters = useCallback(() => {
        try {
            const dashboardId = userdata?.dList?.[0]?.dashboardId || '';
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ FilterName: '', FilterJson: '', DashboardId: dashboardId })
            };
            fetch('/api/Filter/GetUserAdFilter', requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data && data[0] && data[0].filterset) {
                        setUserFilterList(data[0].filterset);
                    }
                })
                .catch(error => {});
        } catch (error) {

        }
    }, [userdata]);

    const handlechangea = useCallback((e) => {
        if (e && e.heading && e.value) {
            // Validate heading is not undefined or invalid
            if (e.heading === 'undefined' || !e.heading) {
                return;
            }
            
            try {
                let Created_Advance_Filter = JSON.parse(localStorage.getItem('Advance_Filter')) || {};
                
                if (Created_Advance_Filter[e.heading]) {
                    if (!Created_Advance_Filter[e.heading].includes(e.value)) {
                        Created_Advance_Filter[e.heading].push(e.value);
                    }
                } else {
                    Created_Advance_Filter[e.heading] = [e.value];
                }
                
                localStorage.setItem('Advance_Filter', JSON.stringify(Created_Advance_Filter));
                localStorage.setItem('Filter_Last_Update_Time', new Date().toString());
                localStorage.setItem('Updated_AdFilter_Status', JSON.stringify(Created_Advance_Filter));
                
            } catch (error) {
                console.error('Error saving filter:', error);
            }
        }
        
        changeData();
        if (handeChangefilter) {
            handeChangefilter(e);
        }
    }, [changeData, handeChangefilter]);

    const handleFilterTypeChange = useCallback((filterType) => {
        setDist_usertype(filterType);
        changeData(undefined, undefined, undefined, filterType);
    }, [changeData]);

    useEffect(() => {
        let newDate = new Date();
        localStorage.setItem('Filter_Last_Update_Time', newDate);
        changeData();
        loadUserFilters();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchInputRef.current && !searchInputRef.current.contains(event.target)) {
                setShowSearchResults(false);
            }
            if (filterDropdownWrapRef.current && !filterDropdownWrapRef.current.contains(event.target)) {
                setFilterDropdownOpen(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Auth checks
    const userType = userService.Get_User_Type();
    if (userService.Check_LoggedIn_Status() === 'Login') {
        return <Redirect to="/login" />;
    }
    if (['admin', 'distributor', 'subadmin'].includes(userType?.toLowerCase())) {
        return <Redirect to='/pageNotFound' />;
    }

    return (
        <PagesWrapper>
            <div className="flex flex-col gap-4">
                <div className="flex items-center">
                    <h1 className="text-2xl font-semibold text-foreground">
                        Pharmacies
                    </h1>
                </div>

                <Card>
                    <CardContent className="analytics-card-content">
                        <div className="flex flex-wrap items-end gap-4">
                            <DateRangePicker
                                className="w-[320px] max-w-full flex-shrink-0 h-10"
                                initialSettings={{
                                    startDate: format(startDate, "MM/dd/yyyy"),
                                    endDate: format(endDate, "MM/dd/yyyy"),
                                    maxDate: new Date(),
                                    locale: {
                                        format: 'MM/DD/YYYY'
                                    }
                                }}
                                onApply={handleCalendar}>
                                <div className="flex items-center gap-0 w-[320px] max-w-full rounded-md overflow-hidden border border-input bg-card hover:shadow-sm transition-shadow h-10">
                                    <div className="flex items-center gap-1 px-3 flex-1">
                                        <span className="text-sm text-muted-foreground whitespace-nowrap">From</span>
                                        <Input
                                            type="text"
                                            className="bg-transparent text-sm cursor-pointer w-full !border-0 outline-none h-auto p-0 rounded-none"
                                            value={format(startDate, "MM/dd/yyyy")}
                                            readOnly
                                        />
                                    </div>
                                    <div className="h-6 w-px bg-border flex-shrink-0" />
                                    <div className="flex items-center gap-1 px-3 flex-1">
                                        <span className="text-sm text-muted-foreground whitespace-nowrap">To</span>
                                        <Input
                                            type="text"
                                            className="bg-transparent text-sm cursor-pointer w-full !border-0 outline-none h-auto p-0 rounded-none"
                                            value={format(endDate, "MM/dd/yyyy")}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </DateRangePicker>

                            {/* Search Input - Takes remaining width */}
                            <div className="relative flex-1 min-w-[200px]" ref={searchInputRef}>
                                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
                                    <Input
                                        type="text"
                                        placeholder="Search"
                                        className="searchFilter pl-9"
                                        value={searchValue}
                                        onChange={handleSearchChange}
                                        onFocus={handleSearchFocus}
                                    />
                                    {searchLoading && <Loader2 className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin text-muted-foreground" />}
                                    {showSearchResults && searchDisplay.length > 0 && (
                                        <div className="absolute top-full left-0 right-0 mt-1 w-full bg-popover border rounded-md shadow-lg z-50 max-h-[200px] overflow-auto">
                                            {searchDisplay.map((item, index) => {
                                                if (index < 5) {
                                                    const n_name = item.cname === "PBM" ? "PCN" : item.cname;
                                                    const isLast = index === Math.min(searchDisplay.length - 1, 4);
                                                    return (
                                                        <div
                                                            key={index}
                                                            className={`flex items-center justify-between px-3 py-2 hover:bg-accent cursor-pointer text-sm ${!isLast ? 'border-b' : ''}`}
                                                            onClick={() => handleSearchItemClick(item)}
                                                        >
                                                            <span className="font-medium">{item.cvalue}</span>
                                                            <span className="text-muted-foreground">{n_name}</span>
                                                        </div>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </div>
                                )}
                            </div>

                            {/* Filter Icon Dropdown */}
                            <div ref={filterDropdownWrapRef} className={cn('filterNewDesign relative flex-shrink-0', filterDropdownOpen && 'active')}>
                                    <Button 
                                        ref={filterButtonRef}
                                        variant="outline" size="icon" className="filter-over" 
                                        onClick={filterDropdown}
                                    >
                                        <SlidersHorizontal className="h-4 w-4" />
                                    </Button>
                                    <div 
                                        className={cn(
                                            'absolute top-full mt-1 w-48 bg-popover border rounded-md shadow-lg z-50',
                                            absoluteMenuAlignClasses(filterMenuAlign),
                                            filterDropdownOpen ? 'block' : 'hidden'
                                        )}
                                    >
                                        <NavLink to="/filter" className="block px-3 py-2 text-sm text-foreground hover:bg-accent transition-colors rounded-t-md">Create New Filter</NavLink>
                                        {userFilterList != null && userFilterList.length > 0 && (
                                            <div className="border-t">
                                                {userFilterList.map((e1, i1) => (
                                                    <div 
                                                        key={i1} 
                                                        data-filterid={e1.dashboardId} 
                                                        onClick={handleAdFilterClick} 
                                                        className="px-3 py-2 text-sm text-foreground hover:bg-accent transition-colors cursor-pointer"
                                                    >
                                                        {e1.filterName}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Direct/Override Dropdown - Wholesaler */}
                                {userdata?.overrideCount > 0 && (
                                    <DropdownMenu onOpenChange={(open) => { if (open) setDirectOverrideAlign(computeMenuAlignFromTrigger(directOverrideTriggerRef.current)); }}>
                                        <DropdownMenuTrigger asChild>
                                            <Button ref={directOverrideTriggerRef} variant="secondary" className="h-10 gap-2 flex-shrink-0">
                                                {dist_usertype}<ChevronDown className="h-4 w-4" />
                                            </Button>
                                        </DropdownMenuTrigger>
                                        <DropdownMenuContent align={directOverrideAlign} className="w-40 p-2">
                                            <DropdownMenuItem 
                                                onClick={() => handleFilterTypeChange('All')}
                                                className="text-left px-3 py-2 text-sm font-medium hover:bg-accent transition-colors cursor-pointer border-b rounded-none"
                                            >
                                                All
                                            </DropdownMenuItem>
                                            <DropdownMenuItem 
                                                onClick={() => handleFilterTypeChange('Direct')}
                                                className="text-left px-3 py-2 text-sm font-medium hover:bg-accent transition-colors cursor-pointer border-b rounded-none"
                                            >
                                                Direct
                                            </DropdownMenuItem>
                                            <DropdownMenuItem 
                                                onClick={() => handleFilterTypeChange('Override')}
                                                className="text-left px-3 py-2 text-sm font-medium hover:bg-accent transition-colors cursor-pointer rounded-none"
                                            >
                                                Override
                                            </DropdownMenuItem>
                                        </DropdownMenuContent>
                                    </DropdownMenu>
                                )}

                                {/* Claim Type Tabs - Only for legacy users */}
                                {(userdata?.isBrokerTypeUser === false && userdata?.isLegacyUser === true) && (
                                    <div className="flex rounded-lg bg-muted p-1 flex-shrink-0">
                                        {ClaimType.map((p, index) => (
                                            <React.Fragment key={index}>
                                                <Button 
                                                    id={p.id} 
                                                    onClick={HandleRXSRadioButton} 
                                                    value={p.value} 
                                                    variant={p.isChecked ? "default" : "ghost"}
                                                    className={cn(
                                                        "px-3 py-2 text-sm font-medium rounded-md whitespace-nowrap cursor-pointer",
                                                        !p.isChecked && "text-muted-foreground hover:text-foreground hover:bg-background"
                                                    )}
                                                >
                                                    {p.pname}
                                                </Button>
                                                {!p.isChecked && index < ClaimType.length - 1 && (
                                                    <div className="w-px bg-border self-stretch my-2" />
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                )}
                        </div>
                    </CardContent>
                </Card>

                {/* Filter Tags - Using FilterTag Component */}
                <FilterTagCom 
                    Rolename={roleInfo.rolename}
                    wh_Id={roleInfo.wh_Id}
                    Roletype={roleInfo.roletype}
                    df={format(safeParseDate(startDate), "yyyyMMdd")}
                    dt={format(safeParseDate(endDate), "yyyyMMdd")}
                    handlechangea={handlechangea}
                    FilterTags={FilterTagList}
                    Loading={true}
                    dist_id={null}
                />

                <div className="grid grid-cols-1 2xl:grid-cols-2 gap-3">
                    {graphData.map((item, index) => (
                        <div key={`graph-widget-${index}`} className="min-h-[400px]">
                            {item.type === "List" && (
                                <ListChartWidget
                                    data={item}
                                    _Index={index}
                                    handlechangea={handlechangea}
                                />
                            )}
                            {item.type === "Column_Pie" && (
                                <ColumnPieChart
                                    data={item}
                                    _Index={index}
                                    handlechangea={handlechangea}
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </PagesWrapper>
    );
}

export default Pharmacies;
